<style lang="scss" >
@import "resources/sass/v1/abstracts/_variables";

.label-block {
    max-width: 276px;

    p {
        font-size: $font-size-in-between;
        line-height: 1.7;
        margin-bottom: 0.7rem;
        color: $body-color;

        @media screen and (min-width: $screen-lg) {
            letter-spacing: 0.53px;
            line-height: 24px;
        }
    }
}
</style>

<template>
    <div class="label-block mb-80">
        <a v-if="link" :href="link" class="d-inline-block">
            <img data-src="/svg/icons/icon-label-primary.svg" alt="label icoon" class="mb-16 lazyload">
            <h2 class="h5">{{ title }}</h2>
            <p v-html="description"></p>
            <span v-if="link.length > 0" class="read-more">{{ readMore }}</span>
        </a>
        <template v-else>
            <img data-src="/svg/icons/icon-label-primary.svg" alt="label icoon" class="mb-16 lazyload">
            <h2 class="h5">{{ title }}</h2>
            <p v-html="description"></p>
            <span v-if="link.length > 0" class="read-more">{{ readMore }}</span>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        },
        readMore: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        }
    }
}
</script>
